import { render } from "./WeDo.vue?vue&type=template&id=44d69f81&scoped=true"
import script from "./WeDo.vue?vue&type=script&lang=js"
export * from "./WeDo.vue?vue&type=script&lang=js"

import "./WeDo.vue?vue&type=style&index=0&id=44d69f81&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d69f81"]])

export default __exports__